<template>
  <div style="height: 100%">
    <div class="contact-pc-body">
      <div class="body">
          <div class="title">{{contact.title}}</div>
          <div class="content">
            <div class="contact-info">{{contact.info}}</div>
            <div class="contact-address">{{contact.address}}</div>
            <img class="contact-image" :src="'static/pic/' + contact.image" />
            <div class="contact-others">{{contact.others}}</div>
          </div>
      </div>
    </div>
    <div class="contact-mobile-body">
      <div class="contact-body">
        <div class="title">{{contact.title}}</div>
          <div class="content">
            <div class="contact-info">{{contact.info}}</div>
            <div class="contact-address">{{contact.address}}</div>
            <img class="contact-image" :src="'static/pic/' + contact.image" />
            <div class="contact-others">{{contact.others}}</div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getCurLan} from '@/util/tools'
export default {
  name: 'contact-page',
  data () {
    return {
        contact:
      {
        title:"联系我们",
          info: "中国科学院物理研究所\n表面物理国家重点实验室SF9组",
          address:"地址：北京市海淀区中关村南三街8号，中科院基础科学园区内B楼",
          image:"",
          others:"电话：010-82648130, Email: khwu（at）ihy.ac.cn"
      },
    }
  },
  mounted () {
    this.contact = getCurLan().contact
  }
}
</script>
<style lang='scss' src='../assets/styles/pc/contact-page.scss'></style>
<style lang='scss' src='../assets/styles/mobile/contact-page.scss'></style>


// WEBPACK FOOTER //
// src/components/Contact.vue